const prefixFormatCurrency = (value) => {
    value = value ?? 0;
    return `$${value.toFixed(2)}`;
};

const suffixFormatCurrency = (value) => {
    value = value ?? 0;
    return `${value.toFixed(2)}%`;
};

const formatNumberWithCommas = (value) => {
    if (value === null || value === undefined || value === 0) {
        return 0;
    }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};


const formatCurrencyWithCommas = (value) => {
    value = value ?? 0; // Default to 0 if value is null or undefined
    return `$${formatNumberWithCommas(value.toFixed(2))}`;

};
const bodyTemplate = (type, rowData) => {
    const value = rowData[type];

    switch (type) {
        case 'fillRate':
            return suffixFormatCurrency(rowData.fillRate);
        case 'revenue':
            return formatCurrencyWithCommas(value)
        case 'erpm':
        case 'rpmr':
            return prefixFormatCurrency(rowData[type]);
        case 'impressions':
        case 'revenue':
        case 'demandRequests':
            return formatNumberWithCommas(rowData[type]);
        default:
            return value !== null && value !== undefined ? value : 0; // Handle default case
    }
};


const fillRateBodyTemplate = (rowData) => {
    return bodyTemplate('fillRate', rowData);
};

const revenueBodyTemplate = (rowData) => {
    return bodyTemplate('revenue', rowData);
};

const erpmBodyTemplate = (rowData) => {
    return bodyTemplate('erpm', rowData);
};

const rpmrBodyTemplate = (rowData) => {
    return bodyTemplate('rpmr', rowData);
};

const impressionsBodyTemplate = (rowData) => {
    return bodyTemplate('impressions', rowData);
};

const demandRequestsBodyTemplate = (rowData) => {
    return bodyTemplate('demandRequests', rowData);
};

// Exporting templates for use in other modules
export {
    fillRateBodyTemplate,
    revenueBodyTemplate,
    erpmBodyTemplate,
    rpmrBodyTemplate,
    impressionsBodyTemplate,
    demandRequestsBodyTemplate,
    prefixFormatCurrency,
    suffixFormatCurrency,
    formatNumberWithCommas
};
